/* eslint-disable @angular-eslint/component-selector */
import {
  AfterViewChecked,
  Component,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
} from '@angular/core';
import { LocationListService } from '@kanzi-apes/kanzi-locations';
import {
  CustomerModel,
  KanziStatus,
  LocationModel,
  RevisionLineFilterModel,
} from '@kanzi-apes/kanzi-models';
import { KanziRestClientService } from '@kanzi-apes/kanzi-rest-api';
import { EnvironmentService } from '@kanzi-apes/kanzi-utils';
import moment from 'moment';

interface totalsSummaryModels {
  current_location_name: string;
  total: number;
}

@Component({
    selector: 'lib-kanzi-locations-bar-chart',
    templateUrl: './kanzi-locations-bar-chart.component.html',
    styleUrls: ['./kanzi-locations-bar-chart.component.scss'],
    standalone: false
})
export class KanziLocationsBarChartComponent
  implements OnInit, OnChanges, AfterViewChecked
{
  @Input() title = '';
  @Input() customer!: CustomerModel;
  @Input() locationType = '';
  // @Input() axisX!: { position: Position; label: string };
  @Input() configService!: { url: string };
  @Input() series!: { nameField: string; labelField: string }[];
  // @ViewChild(DxChartComponent, { static: false }) chart!: DxChartComponent;
  totalsSummary: totalsSummaryModels[] = [];
  filters: RevisionLineFilterModel = { page: 1, page_size: 1 };
  locationsData: LocationModel[] = [];
  today = moment(new Date()).format('YYYY-MM-DD');
  minDateWeek = '';
  maxDateWeek = '';
  minDateMonth = '';
  maxDateMonth = '';
  buttonSelected = 'DAY';
  constructor(
    private locationService: LocationListService,
    private envService: EnvironmentService,
    private apiClientService: KanziRestClientService
  ) {}

  ngOnInit(): void {
    this.minDateMonth = moment(new Date())
      .startOf('month')
      .format('YYYY-MM-DD');
    this.maxDateMonth = moment(new Date()).endOf('month').format('YYYY-MM-DD');
    this.minDateWeek = moment(new Date()).startOf('week').format('YYYY-MM-DD');
    this.maxDateWeek = moment(new Date()).endOf('week').format('YYYY-MM-DD');
  }

  ngOnChanges() {
    this.totalsSummary = [];
    this.locationService
      .getlocationList({
        page: 1,
        page_size: 1000,
        customer_id: this.customer ? this.customer.id : null,
        type__name: this.locationType,
      })
      .subscribe((locations) => {
        this.locationsData = locations.results;
        this.getDataByLocation();
      });
  }

  ngAfterViewChecked() {
    // this.chart.instance.render();
  }

  getDataByLocation(type?: string) {
    this.buttonSelected = type ? type : this.buttonSelected;
    switch (type) {
      case 'MONTH':
        {
          this.filters = {
            ...this.filters,
            created_min: this.minDateMonth,
            created_max: this.maxDateMonth,
          };
        }
        break;
      case 'WEEK':
        {
          this.filters = {
            ...this.filters,
            created_min: this.minDateWeek,
            created_max: this.maxDateWeek,
          };
        }
        break;

      case 'DAY':
        {
          this.filters = {
            ...this.filters,
            created_min: this.today,
            created_max: this.today,
          };
        }
        break;

      default:
        {
          this.filters = {
            ...this.filters,
            created_min: this.today,
            created_max: this.today,
          };
        }
        break;
    }
    this.totalsSummary = [];
    this.locationsData.forEach((location) => {
      this.filters = {
        ...this.filters,
        revision__source_id: location.id,
        customer_id: this.customer ? this.customer.id : null,
        status: KanziStatus.COMPLETED,
      };
      this.apiClientService
        .get(
          `${this.envService.environment?.kongApi}${this.configService.url}`,
          this.filters,
          `Error al obtener los Servicios`
        )
        .subscribe((result: any) => {
          if (result.count > 0) {
            this.totalsSummary.push({
              current_location_name: location.display_name,
              total: result.count,
            });
          }
          this.totalsSummary = ([] as totalsSummaryModels[]).concat(
            this.totalsSummary
          );
        });
    });
  }

  customizeTooltip(arg: any) {
    return {
      text: `${arg.argument}\n${arg.seriesName} : ${arg.valueText}`,
    };
  }
}
